import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getAsianFaqQuestions = (cityName, siteTitle, vehicleType) => [
  {
    question: `How much does Asian food ${vehicleType} catering cost in ${cityName}?`,
    answer: `Asian food ${vehicleType} catering in ${cityName} can range quite a bit, depending on your guest count, menu style, and level of service. Smaller private gatherings might land in the few-hundred-dollar range, while larger corporate events, weddings, and festivals typically scale higher with per-person pricing or event minimums. ${siteTitle} lets you compare real quotes from Asian food ${vehicleType}s in your area, so you can see what fits your budget upfront—no guesswork, no surprise fees.`
  },
  {
      question: `What kinds of Asian cuisine can food ${vehicleType}s serve at events?`,
      answer: `Asian food ${vehicleType}s cover an impressive range of cuisines and flavors. Think Chinese stir-fries, Japanese ramen and sushi rolls, Korean BBQ, Thai curries, Vietnamese pho and bánh mì, poke bowls, dumplings, and creative fusion menus. Many ${vehicleType}s specialize in regional or chef-driven concepts, which makes it easy to build a menu that feels exciting, varied, and genuinely memorable for your guests.`
  },
  {
    question: `Are Asian food ${vehicleType}s a good fit for corporate events and office catering?`,
    answer: `Absolutely. Asian food ${vehicleType}s are one of the most popular choices for corporate catering and office lunches in ${cityName}. Their menus are efficient to serve, easy to customize, and crowd-friendly—especially for teams with diverse tastes. The Asian food ${vehicleType}s on ${siteTitle} are experienced with corporate campuses, tight service windows, and high-volume events, so everything runs smoothly from arrival to cleanup.`
    },
    {
      question: `Can Asian food ${vehicleType}s handle vegetarian, vegan, or gluten-free requests?`,
      answer: `Many Asian food ${vehicleType}s offer vegetarian, vegan, gluten-free, and sometimes halal options, depending on the cuisine. When you submit your catering request, you can call out dietary needs or preferences, and we'll connect you with ${vehicleType}s that are a good match for your group—no awkward last-minute scrambling.`
    },
    {
      question: `How far in advance should I book an Asian food ${vehicleType} for catering?`,
      answer: `For the best selection, it's smart to book an Asian food ${vehicleType} about 3–6 weeks in advance, especially for weddings, summer events, and large corporate gatherings. That said, last-minute bookings can still work if availability allows. The earlier you submit your request, the more options you'll have—and the easier it is to lock in exactly what you want.`
  }
];

function AsianFaq() {
  const { city_name, site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getAsianFaqQuestions(city_name, site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default AsianFaq;
